import React, { useState } from "react";
import AddNewItem from "../../../../components/modals/AddNewItem";
import CourseForm from "../components/CourseForm";
import { DialogActions, Button, CircularProgress } from "@material-ui/core";
import CoursesService from "../../../../../services/CoursesService";
import { useDispatch } from "react-redux";
import { showSnackBar } from "../../../../../redux/actions/ui";
import { makeStyles } from "@material-ui/core/styles";
import { useForm } from "react-hook-form";
import SaveIcon from "@material-ui/icons/Save";
import { parseOccurences } from "../../../../../utils/occurrences";

const useStyles = makeStyles(theme => ({
  // DialogTitle
  DialogActions: {
    justifyContent: "center",
    "& .MuiButton-root": {
      // backgroundColor: 'red'
      minWidth: "12em",
      padding: "0.5em"
    }
  },  
}));

function AddnewCourse(props) {
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [isEditableForm, setIsEditableForm] = useState(true);
  const classes = useStyles();
  const dispatch = useDispatch();

  const { register, errors, handleSubmit, control } = useForm({
    validateCriteriaMode: "all",
    mode: "onChange"
  });
   
  const creteNewCourse = async data => {    
    setIsLoadingSubmit(true);     
    setIsEditableForm(false);
    try{
      data.occurrences = parseOccurences(data.occurrences);
      data.office_hours = parseOccurences(data.office_hours);
      await CoursesService.createCourse(data);
      setIsLoadingSubmit(false);      
      setIsEditableForm(true);
      dispatch(showSnackBar("Successfully edited!"));      
      // We updated the list
      props.updateCourseFromList();
      props.onClose(false);      
    }catch (error) {
      setIsLoadingSubmit(false);
      dispatch(showSnackBar("An error occurred!", 'error'));
      setIsEditableForm(true);
    }  
  };

  const actions = (
    <DialogActions className={classes.DialogActions}>
      <Button onClick={() => props.onClose(false)} color="primary" variant="outlined" >
          Cancel
        </Button>
        <Button 
          type="submit"
          disabled={isLoadingSubmit}           
          onClick={handleSubmit(creteNewCourse)}
          color="primary" 
          autoFocus 
          variant="contained"
          startIcon={
            isLoadingSubmit ? <CircularProgress size={24}/> : <SaveIcon />
          }>
          Save
        </Button>
    </DialogActions>
  )

  return (
    <AddNewItem open={props.open} onClose={props.onClose} isLoading={isLoadingSubmit} actions={actions} >
      <CourseForm isEditableForm={isEditableForm} onSubmit={creteNewCourse} formConfig={ {register, errors, handleSubmit, control} } listTeachers={props.listTeachers} allowEditUsers={false}/>
    </AddNewItem>
  )
}

export default AddnewCourse;